import { render, staticRenderFns } from "./EventBubble.vue?vue&type=template&id=5908e176&scoped=true"
import script from "./EventBubble.vue?vue&type=script&lang=js"
export * from "./EventBubble.vue?vue&type=script&lang=js"
import style0 from "./EventBubble.vue?vue&type=style&index=0&id=5908e176&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908e176",
  null
  
)

export default component.exports